import { restClient } from '@/Core'

import type { DiskContentUrl } from '../Contracts/DiskNode'

/**
 * Підписане посилання на вміст файлу (живе до години):
 * `GET /services/disk/files/{uuid}/content_url`. `inline` — відкрити в
 * браузері (небезпечні типи бек усе одно віддає лише `attachment`),
 * `attachment` — скачати.
 *
 * `recent: false` — відкриття за посиланням не потрапляє в «Нещодавні»
 * (мініатюра у «Властивостях» — не відкриття файлу).
 *
 * `admin: true` — посилання адмін-контексту (`DISK-006` §2.3): файл диска
 * звільненого чи спільного простору, відкритий з адмін-панелі. Бек пускає
 * за `DiskAdminRule::CONTENT` (активний «Мій диск» — ніколи) і пише кожне
 * відкриття в журнал адміністратора.
 */
export const GetDiskContentUrlTask = async (
    uuid: string,
    disposition: 'inline' | 'attachment',
    options: { recent?: boolean; admin?: boolean } = {}
): Promise<DiskContentUrl> => {
    const response = (await restClient.get(
        `/services/disk/files/${encodeURIComponent(uuid)}/content_url`,
        {
            searchParams: {
                disposition,
                ...(options.recent === false ? { recent: 0 } : {}),
                ...(options.admin === true ? { admin: 1 } : {}),
            },
        },
        { forceRefresh: true }
    )) as unknown as { url?: unknown; expiresAt?: unknown } | null

    if (typeof response?.url !== 'string') throw new Error('Не вдалося отримати посилання на файл')

    return { url: response.url, expiresAt: typeof response.expiresAt === 'string' ? response.expiresAt : null }
}
